import type { FC } from "react";
import { useHistory } from "react-router-dom";
import type { ButtonProps } from "@kivra/react-components";
import { Button } from "@kivra/react-components";

interface LinkButtonProps extends ButtonProps {
  to: string;
}

export const LinkButton: FC<LinkButtonProps> = (props) => {
  const history = useHistory();
  const handleNavigation = () => history.push(props.to);
  return (
    <Button {...props} onClick={handleNavigation} size="medium">
      {props.children}
    </Button>
  );
};
